import { baseApiSlice } from '../../commons/base-api.config';
import {
    API_GET_SOCIAL_MEDIA_OF_BRAND_FOR_CLOUD_CAMPAIGN,
    API_SCHEDULE_CONTENT_TO_CLOUD_CAMPAIGN,
} from '../../constants/api';
import { HTTP_METHODS } from '../../constants/http';
import {
    ICCSocialMedia,
    IGetSocialMediaOfABrandForCCRequestPayload,
    IScheduleContentToCloudCampaignRequestPayload,
} from '../../interfaces/social-media.interface';

export const socialMediaApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            scheduleContentToCloudCampaign: builder.mutation<
                string,
                IScheduleContentToCloudCampaignRequestPayload
            >({
                query(data) {
                    return {
                        url: API_SCHEDULE_CONTENT_TO_CLOUD_CAMPAIGN,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
            getSocialMediaOfBrandForCloudCampaign: builder.query<
                ICCSocialMedia[],
                IGetSocialMediaOfABrandForCCRequestPayload
            >({
                query(data) {
                    return {
                        url: `${API_GET_SOCIAL_MEDIA_OF_BRAND_FOR_CLOUD_CAMPAIGN}?organizationId=${data.organizationId}&brandId=${data.brandId}`,
                        method: HTTP_METHODS.GET,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
        };
    },
});

export const {
    useScheduleContentToCloudCampaignMutation,
    useLazyGetSocialMediaOfBrandForCloudCampaignQuery,
} = socialMediaApiSlice;
